import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore";

export const fetchSectionData = createAsyncThunk(
  "events/fetchSectionData",
  async (section, thunkAPI) => {
    try {
      const q = query(
        collection(db, "events"),
        where("status", "==", true),
        where("type", "==", section)
      );

      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log("fetchSectionData : ", items);
      return items;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetcHighlightData = createAsyncThunk(
  "events/fetcHighlightData",
  async () => {
    const q = query(
      collection(db, "events"),
      where("status", "==", true),
      where("type", "==", "highlight")
    );

    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // console.log("fetcHighlightData : ", items);
    return items;
  }
);

export const fetchGalleryData = createAsyncThunk(
  "events/fetchGalleryData",
  async (evtId) => {
    const q = query(
      collection(
        db,
        "gallery_images",
        String(evtId),
        "gallery_images_sub_collection"
      )
    );

    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      }["image"];
    });
    return items;
  }
);

export const clearGalleryData = createAsyncThunk(
  "events/clearGalleryData",
  async (evtId) => {
    const q = query(
      collection(
        db,
        "gallery_images",
        String(evtId),
        "gallery_images_sub_collection"
      )
    );

    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      }["image"];
    });
    return items;
  }
);

export const fetchTopEventsData = createAsyncThunk(
  "events/fetchTopEventsData",
  async () => {
    const q = query(
      collection(db, "events"),
      where("status", "==", true),
      where("type", "==", "top_banner")
    );
    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // console.log("fetchTopEventsData : ", items);
    return items;
  }
);

export const fetchCategoryData = createAsyncThunk(
  "events/fetchCategoryData",
  async () => {
    const q = query(collection(db, "event_categories"));
    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // console.log("fetchCategoryData : ", items);
    return items;
  }
);

const isInDateRange = (target, dateList) => {
  return dateList.some(({ start_date }) => start_date > target);
};

export const fetchUpcommingEvents = createAsyncThunk(
  "events/fetchUpcommingEvents",
  async () => {
    const q = query(
      collection(db, "events"),
      // where("status", "==", true),
      where("avb_date_list", "!=", [])
    );

    const querySnapshot = await getDocs(q);
    const millis = Date.now();
    const ts = Timestamp.fromMillis(millis);
    const items = querySnapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(
        (doc) =>
          doc.status === true &&
          isInDateRange(ts.toMillis(), doc.avb_date_list, doc.title)
      );
    // console.log("fetchUpcommingEvents : ", items);
    return items;
  }
);

export const eventSlice = createSlice({
  name: "events",
  initialState: {
    himalayanSectionData: [],
    intSectionData: [],
    loading: true,
    error: null,
    topEventsData: [],
    topEventsLoading: true,
    upcommingEventsData: [],
    upcommingLoading: true,
    highlightData: [],
    highlightLoading: true,
    categoryData: [],
    categoryLoading: true,
    galleryData: [],
  },
  reducers: {
    cleargalleryData(state) {
      state.galleryData = [];
    },
  },
  extraReducers: (builer) => {
    builer
      //sectiondata
      .addCase(fetchSectionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSectionData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload[0].type === "himalayan") {
          state.himalayanSectionData = action.payload;
        } else {
          state.intSectionData = action.payload;
        }
      })
      .addCase(fetchSectionData.rejected, (state) => {
        state.loading = false;
      })
      /////topevents
      .addCase(fetchTopEventsData.pending, (state) => {
        state.topEventsLoading = true;
      })
      .addCase(fetchTopEventsData.fulfilled, (state, action) => {
        state.topEventsLoading = false;
        state.topEventsData = action.payload;
      })
      .addCase(fetchTopEventsData.rejected, (state) => {
        state.topEventsLoading = false;
      })
      ///UpcommingEvents
      .addCase(fetchUpcommingEvents.pending, (state) => {
        state.upcommingLoading = true;
      })
      .addCase(fetchUpcommingEvents.fulfilled, (state, action) => {
        state.upcommingLoading = false;
        state.upcommingEventsData = action.payload;
      })
      .addCase(fetchUpcommingEvents.rejected, (state) => {
        state.upcommingLoading = false;
      })
      /////highlight
      .addCase(fetcHighlightData.pending, (state) => {
        state.highlightLoading = true;
      })
      .addCase(fetcHighlightData.fulfilled, (state, action) => {
        state.highlightLoading = false;
        state.highlightData = action.payload;
      })
      .addCase(fetcHighlightData.rejected, (state) => {
        state.highlightLoading = false;
      })
      /////categories
      .addCase(fetchCategoryData.pending, (state) => {
        state.categoryLoading = true;
      })
      .addCase(fetchCategoryData.fulfilled, (state, action) => {
        state.categoryLoading = false;
        state.categoryData = action.payload;
      })
      .addCase(fetchCategoryData.rejected, (state) => {
        state.categoryLoading = false;
      })
      /////gallery
      .addCase(fetchGalleryData.pending, (state) => {
        // state.categoryLoading = true;
        state.galleryData = [];
      })
      .addCase(fetchGalleryData.fulfilled, (state, action) => {
        state.galleryData = [];
        state.galleryData = action.payload;
      })
      .addCase(fetchGalleryData.rejected, (state) => {
        // state.categoryLoading = false;
      });
  },
});

export default eventSlice.reducer;
